export default __webpack_public_path__ + "static/media/93a467f70a3e7b27a9b52a686f351dbe.6a81fbb8.woff";